export default "__VITE_ASSET__0ba32d6f__"